module.exports = __webpack_public_path__ + "img/badminton.3d534252.svg";